document.addEventListener('DOMContentLoaded', () => {
  const table = document.getElementById('example1');
  if (table && window.jQuery?.fn?.DataTable) {
    window.jQuery(table).DataTable({ paging: false, info: false });
  }
});

function add_to_cart() {
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  setTimeout(() => {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.querySelector('.header__cart-icon')?.click();
  }, 300);
}

function showCLear(linnum) {
  const control = document.getElementById('clearDate' + linnum);
  if (control) control.style.visibility = 'visible';
}
